import {
  NgModule
} from '@angular/core';
import {
  ButtonsModule
} from '@progress/kendo-angular-buttons';
import {
  DateInputsModule
} from '@progress/kendo-angular-dateinputs';
import {
  DropDownsModule
} from '@progress/kendo-angular-dropdowns';
import {
  InputsModule
} from '@progress/kendo-angular-inputs';
import {GridModule} from '@progress/kendo-angular-grid';
import {ReactiveFormsModule} from '@angular/forms';
import {DialogModule} from '@progress/kendo-angular-dialog';
import {MatDialogModule, MatExpansionPanel, MatIconModule} from '@angular/material';
import {FlexLayoutModule} from '@angular/flex-layout';
import { UploadModule } from '@progress/kendo-angular-upload';
import {TitleCasePipe} from '@angular/common';
import {AgmCoreModule} from '@agm/core';
import {AgmJsMarkerClustererModule} from '@agm/js-marker-clusterer';
import {SchedulerModule} from '@progress/kendo-angular-scheduler';
import {TelehealthComponent} from './telehealth.component';
import {LoadingIndicatorModule} from '../shared/layout/components/loading-indicator';
import {BreadcrumbModule} from '../shared/layout/components/breadcrumb';
import {SharedCommonModule} from '../shared/common';
import {ShopifyService} from '../services/shopify/shopify.service';
import {ExerciseService} from '../services/exercise/exercise.service';
import {MatExpansionModule} from '@angular/material/expansion';
import {TelehealthDialogComponent} from './telehealth-dialog.component';
import {AppointmentService} from '../services/appointment/appointment.service';
import {TooltipModule} from '@progress/kendo-angular-tooltip';
import {TranscriptionService} from '../services/api/transcription.service';

@NgModule({
  declarations: [
    TelehealthComponent,
    TelehealthDialogComponent
  ],
  imports: [
    ButtonsModule,
    DateInputsModule,
    GridModule,
    DropDownsModule,
    InputsModule,
    LoadingIndicatorModule,
    BreadcrumbModule,
    TooltipModule,
    SharedCommonModule,
    ReactiveFormsModule,
    MatExpansionModule,
    SchedulerModule,
    DialogModule,
    UploadModule,
    MatDialogModule,
    MatIconModule,
    FlexLayoutModule,
    AgmCoreModule,
    AgmJsMarkerClustererModule,
  ],
  exports: [
  ],
  providers: [
    ShopifyService,
    ExerciseService,
    TitleCasePipe,
    AppointmentService,
    TranscriptionService
  ],
  entryComponents: [
    TelehealthDialogComponent
  ],
})
export class TelehealthModule {
}
